module.exports = "https://static.energy5.com/_next/static/images/cert3-27c83034027c8fc6b97f50f5300afea6.png";